import { useContext, useEffect, useRef, useState } from "react";
import Modal from "../../../modals/Modal";
import { useTranslation } from "react-i18next";
import Button from "../../../common/Button";
import { PiPaperclip, PiTrash } from "react-icons/pi";
import ThemeContext from "../../../../context/theme/ThemeContext";
import Input from "../../../common/Input";
import Textarea from "../../../common/Textarea";
import { FILE_SIZE_LIMIT } from "../../../../constants/GlobalConstants";
import { humanFileSize } from "../helpers";

const NewFileModal = (props) => {
	const { t } = useTranslation();
	const fileInputRef = useRef(null);
	const { withTheme } = useContext(ThemeContext);
	const [selectedFile, setSelectedFile] = useState(null);
	const [description, setDescription] = useState(false);
	const [isSaveLoading, setIsSaveLoading] = useState(false);
	const { isOpen, onClose } = props;

	const handleSubmit = async () => {
		setIsSaveLoading(true);

		// TODO: Handle upload

		setIsSaveLoading(false);
		onClose();
	};

	const handleFileChange = async (event) => {
		const { files } = event.target;

		if (!files?.[0]) {
			return;
		}

		setSelectedFile(files[0]);
	};

	const handleFileInputClick = () => {
		if (fileInputRef.current) {
			fileInputRef.current.value = "";
		}
	};

	useEffect(() => {
		if (isOpen) {
			setSelectedFile(null);
			setDescription(null);
		}
	}, [isOpen]);

	console.log(selectedFile);

	return (
		<Modal style={{ width: 800 }} isOpen={isOpen} onClose={onClose} label={t("fileUpload")}>
			<div style={{ display: "flex", alignItems: "center", marginTop: 32 }}>
				<div style={{ fontWeight: 500 }} className={withTheme("secondary-text")}>
					{selectedFile ? humanFileSize(selectedFile.size, true, 0) : `0 MB`} /{" "}
					{FILE_SIZE_LIMIT} MB
				</div>

				<div style={{ width: "fit-content", marginLeft: "auto" }}>
					<Button
						type="secondary"
						LeftIcon={PiPaperclip}
						onClick={() => {
							fileInputRef.current.click();
						}}
					>
						{t("selectFile")}
					</Button>

					<input
						ref={fileInputRef}
						type="file"
						multiple={false}
						style={{ display: "none" }}
						onChange={handleFileChange}
						onClick={handleFileInputClick}
					/>
				</div>
			</div>

			<div style={{ display: "flex", alignItems: "flex-end", gap: 16 }}>
				<div style={{ marginTop: 16, width: "calc(100% - 40px)" }}>
					<Input
						disabled
						label={t("fileName")}
						placeholder={t("name")}
						value={selectedFile?.name || ""}
					/>
				</div>

				<Button
					isDisabled={!selectedFile}
					tooltip={t("removeFile")}
					type="secondary-icon"
					onClick={() => setSelectedFile(null)}
				>
					<PiTrash />
				</Button>
			</div>

			<div style={{ marginTop: 16 }}>
				<Textarea
					label={t("fileDescription")}
					placeholder={t("description")}
					value={description || ""}
					style={{ resize: "none" }}
					onChange={(e) => setDescription(e.target.value)}
				/>
			</div>

			<div
				style={{
					display: "flex",
					alignItems: "center",
					gap: 8,
					marginTop: 32,
					width: "fit-content",
					marginLeft: "auto",
				}}
			>
				<Button style={{ minWidth: 100 }} type="secondary" onClick={onClose}>
					{t("cancel")}
				</Button>
				<Button
					isDisabled={!selectedFile || !description}
					style={{ minWidth: 132 }}
					onClick={handleSubmit}
				>
					{t("uploadFile")}
				</Button>
			</div>
		</Modal>
	);
};

export default NewFileModal;
